<template>
    <div class="row">
        <div class="col-md-4">
            Item:<br/>
            <select class="skipCheckoutItem form-control" v-model="skipCheckoutItem">
                <option value="">--select one--</option>
                <optgroup label="Packages">
                    <option v-for="pack in packages" :value="'k-'+pack.package_id" :key="pack.package_id">{{ getPackageData(pack.package_id, 'name') }}</option>
                </optgroup>
                <optgroup label="Deals">
                    <option v-for="deal in deals" :value="'d-'+deal.deal_id" :key="deal.deal_id">{{ getDealData(deal.deal_id, 'name') }}</option>
                </optgroup>
                <optgroup label="Products">
                    <option v-for="product in products" :value="'p-'+product.product_id" :key="product.product_id">{{ getProductData(product.product_id, 'name') }}</option>
                </optgroup>
            </select>
        </div>
        <div class="col-md-8">
            Message:<br/>
            <textarea class="messageHtml form-control" v-model="rule.settings.message_html"></textarea>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            allpackages: Array,
            alldeals: Array,
            allproducts: Array,
            packages: Array,
            deals: Array,
            products: Array,
            rule: Object
        },
        data: () => {
            return {
                skipCheckoutItem: ''
            }
        },
        methods: {
            getPackageData(pack_id, type) {
                let pack_details = this.allpackages.filter(function(pack) {
                                return pack.id === pack_id
                            })[0]
                return pack_details ? pack_details[type] : '';
            },
            getDealData(deal_id, type) {
                let deal_details = this.alldeals.filter(function(deal) {
                                return deal.id === deal_id
                            })[0]

                return deal_details ? deal_details[type] : ''
            },
            getProductData(product_id, type) {
                let product_details = this.allproducts.filter(function(product) {
                                return product.id === product_id
                            })[0]
                return product_details ? product_details[type] : ''
            },
            selectSkipCheckoutItem() {
                if(this.rule.settings.package_id) {
                    this.skipCheckoutItem = 'k-'+this.rule.settings.package_id;
                } else if(this.rule.settings.deal_id) {
                    this.skipCheckoutItem = 'd-'+this.rule.settings.deal_id;
                } else if(this.rule.settings.product_id) {
                    this.skipCheckoutItem = 'p-'+this.rule.settings.product_id;
                }
            },
            updateSkipCheckoutItem() {
                var packageId = '';
                var dealId = '';
                var productId = '';
                var message = this.rule.settings.message_html;
                if(this.skipCheckoutItem) {
                    var typeItem = this.skipCheckoutItem.split('-');
                    if( typeItem[0] == 'k' ) {
                        packageId = Number(typeItem[1]);
                    }else if( typeItem[0] == 'd' ) {
                        dealId = Number(typeItem[1]);
                    }else if( typeItem[0] == 'p' ) {
                        productId  = Number(typeItem[1]);
                    }
                }
                this.rule.settings = {
                    package_id: packageId,
                    deal_id: dealId,
                    product_id: productId,
                    message_html: message
                }
            }
        },
        mounted() {
            this.selectSkipCheckoutItem();
            
            this.rule.settings = this.rule.settings ? this.rule.settings : {};
            this.rule.settings.message_html  = this.rule.settings.message_html ? this.rule.settings.message_html : '<main class="receipt-content"><div class="thanks-box"><div class="row"><div class="col-md-10 col-md-offset-1 col-sm-12 col-xs-12 text-center"><div class="thanks-box_icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="335.765px" height="335.765px" viewBox="0 0 335.765 335.765" style="enable-background:new 0 0 335.765 335.765;" xml:space="preserve"><g><polygon class="chckmrk" points="311.757,41.803 107.573,245.96 23.986,162.364 0,186.393 107.573,293.962 335.765,65.795" /></g></svg></div><div class="thanks-box_heading"><h2 class="thanks-box_title">Thanks!</h2><p id="receipt-congrats">Congratulations! You have successfully signed up!</p></div><div class="thanks-box_inner">Please check your email for further instructions.</div></div></div></div></main>';
        },
        watch: {
            skipCheckoutItem() {
                this.updateSkipCheckoutItem()
            }
        }
    }
</script>